import { Typography } from "@mui/material";
import { SettingsPageShell } from "../components/settings-page-shell.component";

export const SettingsRolesPage = () => (
  <SettingsPageShell activeTab="roles">
    <Typography variant="body1" color="text.secondary" sx={{ px: "15px" }}>
      Roles and permissions management will be available here.
    </Typography>
  </SettingsPageShell>
);
